/* eslint-disable no-undef */
code

<template>
    <div class="container">
        <div class="row fh-row justify-content-center">
            <div class="col-md-6 pl-0 pr-0 align-self-center">
                <mdb-card class="z-depth-1 card-height">
                  <mdb-card-header color="white">
                    <div class="container-fluid">
                      <div class="row">
                        <div :class="$store.state.reseller_logo? 'col-6': 'col-3'" class="col-md-4 align-self-center text-left">
                          <img v-if="$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-2': 'col-6'" class="col-md-4">
                          <img v-if="!$store.state.reseller_logo" src="@/assets/truid_logo.svg" alt="Card image cap" class="img-fluid"/>
                        </div>
                        <div :class="$store.state.reseller_logo? 'col-4': 'col-3'" class="col-md-4 col-4 align-self-center text-right">
                          <img v-if="$store.state.reseller_logo" :src="$store.state.reseller_logo" alt="Card image cap" class="img-fluid img-banner"/>
                        </div>
                      </div>
                    </div>
                  </mdb-card-header>
                    <mdb-card-body class="text-center">
                      <div class="container-fluid grid-y-center">
                        <div class="row">
                          <div class="col-12">
                            <mdb-progress class="mb-3" style="width: 100%; float:left"
                                          :height="20" :value="$store.state.step/$store.state.totalSteps * 100">
                              {{ $store.state.step }}/{{ $store.state.totalSteps }}
                            </mdb-progress>
                          </div>
                        </div>
                        <div v-if="demo" class="row hh-row" @click="changeDemoElements">
                          <div class="col-12 align-self-center">
                                                          <h3>Document Detection</h3>
                            <h5 v-if="demoStep === 'First'" class="text-primary">{{ $t("firstStep") }}</h5>
                            <h5 v-if="demoStep === 'Second'" class="text-primary">{{ $t("secondStep") }}</h5>
                            <h5 v-if="demoStep === 'Third'" class="text-primary">{{ $t("thirdStep") }}</h5>
                            <p class="w-75 mx-auto">{{ instruction }}</p>
                            <img width="250" :src="animation_src" style="background-color: rgb(219 221 225 / 80%);" />
                          </div>
                          <div class="col-12 align-self-center mt-4">
                            <div class="row justify-content-center text-center">
                              <div class="col-md-12">
                                <span class="dot" :class="demoStep === 'First'? 'primary-color-dark': ''"></span>
                                <span v-if="cardSteps > 1" class="dot" :class="demoStep === 'Second'? 'primary-color-dark': ''"></span>
                                <span v-if="cardSteps > 2" class="dot" :class="demoStep === 'Third'? 'primary-color-dark': ''"></span>
                              </div>
                              <p><b>{{ $t("nextStepMsg") }}</b></p>
                            </div>
                          </div>
                        </div>
                        <div v-else class="hh-row flex-center" style="height: 65vh;">
                          <div class="col-12 align-self-center">
                            <!--                                    <h4>ID Document Verification</h4>-->
                            <card-capture-new v-on:captureComplete="handleWebcamCaptureOpenCV"></card-capture-new>

                          </div>
                        </div>
                      </div>
                    </mdb-card-body>
                  <mdb-card-footer>
                    <div class="col-12 align-self-center">
                      <div class="row justify-content-center">
                        <div class="col-md-12 mb-1 ">
                          <mdb-btn
                              v-if="!demo"
                              :disabled="!validated"
                              style="font-size: 15px" block color="primary" class="next-btn" size="md"
                              @click="$router.push($store.state.configPath[$store.state.step])">
                            {{ $t("next") }}
                            <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                          </mdb-btn>
                          <mdb-btn
                              v-else
                              @click="demo=false"
                              style="font-size: 15px" block color="primary" class="next-btn" size="md">
                            {{ $t("skip") }}
                            <i style="font-size: 22px" class="fa-arrow-right fas fa-2x float-right"></i>
                          </mdb-btn>
                        </div>
                      </div>
                    </div>
                  </mdb-card-footer>
                </mdb-card>
            </div>
        </div>
        <div id="overlay" v-if="spinner">
            <div style="position: fixed;top: 50%;left: 45%; width: 10%;" class="text-center text-white">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>

                </div>
                <p>{{spinner_message}}</p>
            </div>
        </div>
    </div>
</template>

<script>

// import WebcamCaptureOpenCV from "@/components/WebcamCaptureOpenCV";
import * as cardCenter from "../../assets/Card_Center.gif";
import {i18n} from "../../translations";
// import * as rightFace from "../../assets/3D_Face_Right.gif";
// import * as leftFace from "../../assets/3D_Face_Left.gif";
import CardCaptureNew from "@/components/CardCaptureNew";

export default {
    name: "About",
    components: {
      CardCaptureNew,
    },
    data() {
        return {
            spinner:false,
            faceDetected: false,
            validated: false,
            demo: true,
            demoStep: 'First',
            cardSteps: 1,
            instruction: this.$t("bringCardInBox"),
            animation_src: cardCenter,
            spinner_message: this.$t("waitMsg"),
            docAuthenticityRequired: false,
            backFrameRequired: false,
            idSelfieRequired: false,
            ocrRequired: true
        };
    },
  mounted() {
    i18n.locale = this.$store.state.language
    this.$store.commit('assignStep', this.$route.path)
    this.readStepConfig()
  },
  methods: {
        readStepConfig() {
          const currentStep = this.$store.state.config[this.$store.state.step - 1]
          this.docAuthenticityRequired = currentStep.step_config.document_authenticity || false
          this.backFrameRequired = currentStep.step_config.document_backside_capture || false
          if (this.docAuthenticityRequired === true) {
            this.cardSteps += 1
          }
          if (this.backFrameRequired === true) {
            this.cardSteps += 1
          }
          this.idSelfieRequired = this.$store.state.idSelfieRequired
        },
        changeDemoElements() {
          if (this.demoStep === "First") {
            if (this.docAuthenticityRequired || this.backFrameRequired) {
              if (this.docAuthenticityRequired) {
                this.instruction = this.$t("bringCardInFlash")
              } else {
                this.instruction = this.$t("bringBackCardInBox")
              }
              this.demoStep = "Second"
            } else {
              this.demo = false
            }
          } else if (this.demoStep === "Second") {
            if (this.backFrameRequired) {
              this.instruction = this.$t("bringBackCardInBox")
              this.demoStep = "Third"
            } else {
              this.demo = false
            }
          } else if (this.demoStep === "Third") {
            this.demo = false
          }
        },
        handleWebcamCaptureOpenCV(image) {
            this.spinner = true;
            this.spinner_message= this.$t("uploading")
            this.validated = true;
            this.spinner_message = this.$t("matchingFaces")
            if (this.idSelfieRequired) {
              this.idToSelfieMatching()
            }
            if (this.ocrRequired) {
              this.runOCR()
            }
        },
        idToSelfieMatching() {
            let formData = new FormData();
            formData.append('session', this.$store.state.session_id);
            this.$http.post("/id-to-selfie-matching", formData).then(r => {
              formData = new FormData();
              formData.append('session_id', this.$store.state.session_id);
              const urlSearchParams = new URLSearchParams(window.location.search);
              const params = Object.fromEntries(urlSearchParams.entries());
              if (r.data.face_status !== false) {
                this.idSelfieRequired = false
                this.spinner = !(this.idSelfieRequired === false && this.ocrRequired === false);
                console.log('id id selfie req: ', this.idSelfieRequired)
                console.log('id ocr req: ', this.ocrRequired)
                if (this.idSelfieRequired === false && this.ocrRequired === false) {
                  this.$router.push({path:this.$store.state.configPath[this.$store.state.step], query:params})
                }
              } else {
                this.spinner = false
                this.$router.push('/complete')
              }
            }).catch(err => {
              this.spinner = false;
              this.handleError(err)
            })
        },
        runOCR() {
            let formData = new FormData();
            formData.append('session', this.$store.state.session_id);
            formData.append('language', this.$store.state.language);
            this.$http.post("/run-ocr", formData).then(r => {
              formData = new FormData();
              formData.append('session_id', this.$store.state.session_id);
              const urlSearchParams = new URLSearchParams(window.location.search);
              const params = Object.fromEntries(urlSearchParams.entries());
              if (r.data.status !== false) {
                this.ocrRequired = false
                this.spinner = !(this.idSelfieRequired === false && this.ocrRequired === false);
                console.log('ocr id selfie req: ', this.idSelfieRequired)
                console.log('ocr ocr req: ', this.ocrRequired)
                if (this.idSelfieRequired === false && this.ocrRequired === false) {
                  this.$router.push({path:this.$store.state.configPath[this.$store.state.step], query:params})
                }
              } else {
                this.spinner = false
                this.$router.push('/complete')
              }
            }).catch(err => {
              this.spinner = false;
              this.handleError(err)
            })
        },
        handleError(err) {
          if (err.response.status === 400){
            if ('non_field_errors' in err.response && err.response.non_field_errors.length>0){
              this.showError(err.response.non_field_errors[0])
            }
            else if ('data' in err.response){
              if ('non_field_errors' in err.response.data && err.response.data.non_field_errors.length>0){
                this.showError(err.response.data.non_field_errors[0])
              }
              else{
                let error = ""
                if (typeof err.response.data === "object") {
                  error = err.response.data[0]
                } else {
                  error = JSON.stringify(err.response.data)
                }
                this.showError(error)
              }

            }
            else{
              this.showError(JSON.stringify(err.response))
            }
          } else if (err.response && err.response.status === 401) {
            this.$router.push('/expired')
          }
          else {
            const error = err.response? err.response: err
            this.showError(error)
          }
        },
        showError(message, cancelButton=false) {
        const options = {
          title: typeof message === "object"? "Error": message,
          text: "",
          icon: 'question',
          showCancelButton: cancelButton,

          confirmButtonText: this.$t("tryAgain"),
          cancelButtonText: this.$t("no"),
          allowOutsideClick: false,
          allowEscapeKey: false,
          focusConfirm: false,
          customClass: {
            confirmButton: "btn btn-primary btn-md ripple-parent",
            cancelButton: "btn  btn-md ripple-parent"
          },
          buttonsStyling: false,
        };

        this.$swal.fire(options).then(res => {
          if (res.value) {
            window.location.reload();
            // eslint-disable-next-line no-undef
          }
        })

      },
        showValidationErrors(errs) {
            this.validated = "failed";
            for (let errField in errs) {
                const options = {
                    title: 'Face did not match',
                    text: "Do you want to continue",
                    icon: 'question',
                    showCancelButton: true,

                    confirmButtonText: this.$t("yesContinue"),
                    cancelButtonText: this.$t("no"),
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    focusConfirm: false,
                    customClass: {
                        confirmButton: "btn btn-primary btn-md ripple-parent",
                        cancelButton: "btn  btn-md ripple-parent"
                    },
                    buttonsStyling: false,
                };

                this.$swal.fire(options).then(res => {
                    if (res.value) {
                      this.$router.push('/pre-agent')
                    // eslint-disable-next-line no-undef
                    } else if (res.dismiss === "cancel") {
                      this.$router.push('/')
                    }
                })

                break
                // this.$toast.error(errs[errField][0], {position: 'top', duration: 5000})

            }
        },
    }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

$image-path: "~@/../mdb/mdbvue/img";
</style>
